import { getDelayAction } from 'automaton/actions/DelayAction'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { getFreespinStartState } from 'automaton/states/FreespinsStartState'
import { signal } from 'services/SignalsService'
import { timings } from 'settings/custom/freespins'
import { spinSettings } from 'settings/custom/reels'

export function getFreespinAddState(doubleFs) {
  const name = 'FS-ADD'
  signal.dispatch('FREEBET:Enabled', false)
  signal.dispatch('AUTO:OFF')
  if(spinSettings.hasOwnProperty('gamble') && spinSettings.gamble){
    game.models.GambleModel.setIsGamble(false)
  }

  if(spinSettings.hasOwnProperty('doubleFSSkip')){
    doubleFs = spinSettings.doubleFSSkip
  }

  const actions = doubleFs || timings.intro ? [getDelayAction(timings.add)] : []
  const transition = () => doubleFs
    ? getFreespinsSpinState()
    : getFreespinStartState()

  return {
    name,
    actions,
    transition,
  }
}
